import { styleSizes } from 'constants/styleSizes';
import styled from 'styled-components';
import { colors } from 'constants/colors';

export type InputFieldContainerProps = {
  labelPosition?: 'left' | 'center';
  labelColor?: string;
  labelSize?: string;
  labelWeight?: string;
  borderColor?: string;
  inputHeight?: string;
  inputTextColor?: string;
  inputFontSize?: string;
  inputFontWeight?: string;
  inputBackgroundColor?: string;
  error?: boolean;
  success?: boolean;
  width?: string;
  marginBottom?: string;
  iconUrl?: string;
  iconWidth?: number;
  iconHeight?: number;
  iconTop?: number;
  iconRight?: number;
  placeholderFontSize?: string;
  placeholderColor?: string;
  innerLabel?: string;
  $hasInnerLabel?: boolean;
};

export const FormInputFieldContainer = styled.div<InputFieldContainerProps>`
  position: relative;
  width: ${(props) => props.width ?? "100%"};
  margin-bottom: ${(props) => props.marginBottom ?? "20px"};
  color: ${colors.white};

  .inputWrapper {
  position: relative;
  width: 100%;
}

.innerLabel {
  position: absolute;
  top: 5px;
  left: 11px;
  z-index: 1;
  pointer-events: none;

  font-family: 'Titillium Web', sans-serif;
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: ${(props) =>
    props.error ? colors.red : colors.noBookingText};
}

${(props) =>
  props.$hasInnerLabel &&
  `
    .inputWrapper input {
      padding-top: 18px;
      padding-bottom: 4px;
    }
  `}

  .icon {
    position: absolute;
    right: ${(props) => props.iconRight ?? 15}px;
    top: ${(props) => props.iconTop ?? 15}px;
    width: ${(props) => props.iconWidth ?? 20}px;
    height: ${(props) => props.iconHeight ?? 20}px;
    z-index: 100;
  }

  .iconWithHint {
    cursor: default;

    > span {
      width: 100%;
      height: 100%;
    }

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  input {
    font-size: ${(props) => props.inputFontSize ?? "16px"};
    font-weight: ${(props) => props.inputFontWeight ?? "400"};
    font-family: "Titillium Web", sans-serif;
    width: 100%;
    box-sizing: border-box;
    height: ${(props) => props.inputHeight ?? "40px"};
    border: 1px solid
      ${(props) =>
        props.error
          ? colors.red
          : props.borderColor ?? colors.signInBorderColor};
    color: ${(props) => props.inputTextColor ?? colors.black};
    padding-left: 10px;
    background-color: ${(props) => props.inputBackgroundColor ?? colors.white};

    :focus {
      border-color: ${(props) => (props.error ? colors.red : colors.hoverBlue)};
    }
    border-radius: 0 !important;
    -webkit-appearance: none;
    appearance: none;
    &::placeholder {
      font-size: ${(props) => props.placeholderFontSize ?? "16px"};
      color: ${(props) => props.placeholderColor ?? colors.borderGrey3};
      opacity: 1;
    }
  }

  label {
    display: flex;
    flex-direction: row;
    width: 100%;
    font-size: ${(props) => props.labelSize ?? "14px"};
    font-weight: ${(props) => props.labelWeight ?? "600"};
    color: ${(props) =>
      props.error ? colors.red : props.labelColor ?? colors.noBookingText};
    margin-bottom: 8px;
    letter-spacing: 0.75px;
    text-align: ${(props) =>
      props.labelPosition === "center" ? "center" : "left"};
    line-height: 21px;
    align-items: center;
    .required {
      font-size: 18px;
      color: ${colors.red};
      margin-left: 2px;
    }

    .highLight {
      font-weight: bold;
    }

    .infoIconHolder {
      height: 12px;
      display: flex;
      margin-left: 5px;

      .infoIcon {
        width: 14px;
        height: 14px;
        cursor: help;
      }
    }
  }

  .warning {
    width: 100%;
    height: 20px;
    line-height: 15px;
    position: absolute;
    color: ${colors.red};
    font-size: 14px;
    font-weight: 400;
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
    text-align: left;
    margin-top: 2px;
  }

  .success {
    width: 100%;
    height: 20px;
    line-height: 20px;
    position: absolute;
    color: ${colors.questionLinkText};
    font-size: 16px;
    font-weight: 600;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-top: 5px;
  }

  @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
    .warning {
      white-space: normal;
      overflow: visible;
      text-overflow: unset;
    }
  }
`;
